import { getConfidenceClass } from "../../Document/getConfidenceClass";
import { GetHighlightedText } from "../../Document/getHighlightedText";
import { State } from "../../types";

export type ClearValueAction = Readonly<{
  type: "CLEAR VALUE";
  valueKey: string;
}>;

export const clearValue = (state: State, action: ClearValueAction): State => {
  if (!(action.valueKey in state.values)) {
    return state;
  }
  const values = {
    ...state.values,
    [action.valueKey]: {
      ...state.values[action.valueKey],
      confidence: 1.0,
      idRef: null,
      value: "",
      valueRaw: "",
    },
  };
  let blocks = state.blocks;
  const idRef = state.values[action.valueKey].idRef;
  if (idRef !== null && idRef in blocks) {
    const block = blocks[idRef];
    if (block.references.indexOf(action.valueKey) >= 0) {
      const newBlock = {
        ...block,
        references: block.references.filter(r => r !== action.valueKey),
      };
      blocks = {
        ...blocks,
        [idRef]: {
          ...newBlock,
          confidenceClass: getConfidenceClass(newBlock, state.confidenceThreshold, values),
          highlights: GetHighlightedText(blocks[idRef], state.taxonomy.taxonomyObject, values),
        },
      };
    }
  }
  return {
    ...state,
    activeValue: action.valueKey,
    blocks,
    modified: true,
    values,
  };
};
